import Vue from 'vue';
const SeoIndexerComponent = () => import(
    /* webpackChunkName: "seoIndexer" */
    '~/components/shared/seo-indexer-component.vue'
).then(m => m.default);

const COOKIE = {
    SHOW: 'dm_show_seo_indexer',
    COLLAPSED: 'dm_seo_indexer_collapsed',
};

class SEOIndexer {
    constructor() {
        this.createComponent();
    }

    createComponent(element, model) {
        const el = this.createDomElement();
        const isExpanded = !DM.Utils.getCookie(COOKIE.COLLAPSED);

        return new Vue({
            el,
            components: {
                'dm-seo-indexer': SeoIndexerComponent
            },
            template: `<dm-seo-indexer v-on:close="handleClose"
                            v-if="show"
                            v-on:toggleExpand="handletoggleExpand"
                            :show="show" :isExpanded="isExpanded"/> `,
            data: () => ({
                show: true,
                isExpanded,
            }),
            methods: {
                handleClose() {
                    this.show = false;
                    DM.Utils.deleteCookie(COOKIE.SHOW);
                },
                handletoggleExpand() {
                    this.isExpanded = !this.isExpanded;
                    if (this.isExpanded) {
                        DM.Utils.deleteCookie(COOKIE.COLLAPSED)
                    } else {
                        DM.Utils.setCookie(COOKIE.COLLAPSED, true, 8);
                    }
                }
            }
        });
    }

    createDomElement() {
        const element = document.createElement('div');
        document.body.appendChild(element);
        return element;
    }
}

if (DM.Utils.getCookie(COOKIE.SHOW)) {
    new SEOIndexer();
}
